import { createAction } from '@reduxjs/toolkit'
import { NoteBulkRequest, 
    NoteBulkStatusResponse, 
    BulkRedoRequest, 
    BulkRedoStatusResponse 
} from '../api'
import { BulkRefinalizeRequest, BulkRefinalizeResponse } from '../api/refinalize'
import { BulkGetStatusRequest, BulkGetStatusResponse } from '../api/status'
import { BulkCancelRequest, BulkCancelStatusResponse } from '../api/cancel'
import { 
    BulkOperationDownloadRequest, 
    BulkOperationDownloadResponse, 
    BulkOperationRequest, 
    BulkOperationResponse, 
    BulkOperationStatusRequest, 
    BulkOperationStatusResponse 
} from '../api/bulkOperations'

export const tabIndexChange = createAction<number>('TAB_INDEX_CHANGE')

export const bulkCommentRequest = createAction<NoteBulkRequest>('BULK_COMMENT_REQUEST')
export const bulkCommentStatusReceived = createAction<NoteBulkStatusResponse>('BULK_COMMENT_RECEIVED')
export const bulkRefinalizeRequest = createAction<BulkRefinalizeRequest>('BULK_REFINALIZE_REQUEST')
export const bulkRefinalizeReceived = createAction<BulkRefinalizeResponse>('BULK_REFINALIZE_RECEIVED')
export const bulkRedoRequest = createAction<BulkRedoRequest>('BULK_REDO_REQUEST')
export const bulkRedoStatusResponse = createAction<BulkRedoStatusResponse>('BULK_REDO_RESPONSE')
export const bulkResultsReset = createAction<any>('BULK_RESULTS_RESET')
export const bulkGetStatusRequest = createAction<BulkGetStatusRequest>('BULK_GET_STATUS_REQUEST')
export const bulkGetStatusResponse = createAction<BulkGetStatusResponse>('BULK_GET_STATUS_RESPONSE')
export const bulkCancelRequest = createAction<BulkCancelRequest>('BULK_CANCEL_REQUEST')
export const bulkCancelStatusResponse = createAction<BulkCancelStatusResponse>('BULK_CANCEL_RESPONSE')

// Global Bulk Operations Actions
export const bulkOperationRequest = createAction<BulkOperationRequest>('BULK_OPERATION_REQUEST')
export const bulkOperationResponse = createAction<BulkOperationResponse>('BULK_OPERATION_RESPONSE')
export const bulkOperationStatusRequest = createAction<BulkOperationStatusRequest>('BULK_OPERATION_STATUS_REQUEST')
export const bulkOperationStatusResponse = createAction<BulkOperationStatusResponse>('BULK_OPERATION_STATUS_RESPONSE')
export const bulkOperationDownloadResultRequest = createAction<BulkOperationDownloadRequest>('BULK_OPERATION_DOWNLOAD_RESULT_REQUEST')
export const bulkOperationDownloadResultResponse = createAction<BulkOperationDownloadResponse>('BULK_OPERATION_DOWNLOAD_RESULT_RESPONSE')